module.exports = __webpack_public_path__ + "static/media/nofiles.faed8bf3.svg";